import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from 'shared/actions/searchForm';
import queryString from 'query-string';
import { withTranslate } from 'shared/hocs/withTranslate';
import { DesktopRightSidebar } from 'shared/components/BannerAll';
import { toLocalized } from 'shared/helpers/locale';
import { Googletag } from 'shared/modules';
import { generateSearchQuery, generateSparesSearchUrl } from 'shared/helpers/urls';
import LINKS from 'desktop/constants/navigation';
import PageTitle from 'desktop/components/PageTitle/PageTitle';
import InlineNav from 'desktop/components/InlineNav/InlineNav';
import Paginate from 'desktop/components/Paginate/Paginate';
import SeoTexts from 'shared/components/SeoTexts/SeoTexts';
import CanonicalLinks from 'desktop/components/CanonicalLinks/CanonicalLinks';
import SearchInput from 'desktop/components/SearchInput/SearchInput';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import SpareSeoLinks from 'shared/components/SpareSeoLinks/SpareSeoLinks';
import { adjustLinksTitle } from 'shared/helpers/common';
import { SpareRubricsLinks } from 'shared/components/SpareRubricsLinks/SpareRubricsLinks';

import SpareSearchBar from './components/SpareSearchBar/SpareSearchBar';
import PartList from './components/PartList/PartList';
import SortLine from './components/SortLine/SortLine';
import history from '../../../history';
import s from './Spareparts.css';

const PER_PAGE = 20;

class Spareparts extends React.Component {
  static propTypes = {
    queryParams: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    query: PropTypes.shape().isRequired,
    currentPage: PropTypes.number.isRequired,
    formResults: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
    linkPrefix: PropTypes.string,
    canonicalList: PropTypes.arrayOf(PropTypes.shape()),
    seoCharacteristics: PropTypes.shape().isRequired,
    rubricsLinks: PropTypes.arrayOf(PropTypes.shape()),
    // search
    transportType: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    //
    t: PropTypes.func.isRequired,
    currentPath: PropTypes.string,
  };
  static defaultProps = {
    canonicalList: null,
    rubricsLinks: null,
    location: null,
    linkPrefix: '',
    currentPath: '/zapchasti',
  };

  handleSearchSubmit = query => {
    const basePath = `/${generateSparesSearchUrl({})}`;
    const searchPath = `${basePath}?${queryString.stringify(generateSearchQuery({ query }))}`;

    history.push(toLocalized(searchPath, this.props.locale));
  };

  render() {
    const {
      title,
      queryParams,
      currentPage,
      formResults,
      canonicalList,
      seoCharacteristics,
      rubricsLinks,
      // search
      transportType,
      formData,
      formVocabulary,
      selectedActions,
      formState,
      url,
      query,
      linkPrefix,
      location,
      t,
      currentPath,
    } = this.props;

    // /zapchasti/ === /zapchasti/avto/
    const currentUrl =
      transportType.id === 1 ? `/${generateSparesSearchUrl({})}/avto/`.replace(/\/\//g, '/') : url;

    const result = formResults[`spares-${queryParams}`];
    const parts = result && result.results;
    const pageCount = result ? Math.ceil(result.count / PER_PAGE) : 1;
    const h2First = t('SPAREPARTS_TITLE_H2_1');
    const h2Second = t('SPAREPARTS_TITLE_H2_2');
    const h2Third = t('SPAREPARTS_TITLE_H2_3');
    const h2Fourth = t('SPAREPARTS_TITLE_H2_4');

    let prefix = t('Запчасти на');
    if (formState.make) {
      prefix = `${prefix} ${formState.make.title || formState.make}`;
    }

    const canonicalListData = adjustLinksTitle(canonicalList, prefix);

    return (
      <div className={s.page} style={{ paddingTop: '20px' }}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={s.mainCell}>
              <h2 className={s.h2}>
                {h2First}
              </h2>
              <div className={s.searchWrapper}>
                <SearchInput
                  placeholder={t('Введите номер или название запчасти')}
                  onSubmit={this.handleSearchSubmit}
                  value={formState.query}
                />
              </div>
              <h2 className={s.h2}>
                {h2Second}
              </h2>
              <div className={s.navWrapper}>
                <InlineNav currentRoute={currentUrl} navLinks={LINKS.SPARES_LINKS} />
              </div>
              <SpareSearchBar
                transportType={transportType}
                formData={formData}
                formState={formState}
                formVocabulary={formVocabulary}
                selectedActions={selectedActions}
              />
              <PageTitle title={title} />
              {canonicalListData &&
                canonicalListData.length > 0 &&
                <React.Fragment>
                  <h2 className={s.h2}>
                    {h2Third}
                  </h2>
                  <CanonicalLinks
                    key={transportType.id}
                    canonicalList={canonicalListData}
                    query={query}
                    linkPrefix={linkPrefix}
                    location={location}
                    transportType={transportType}
                    columnsNum={3}
                  />
                </React.Fragment>}
              <h2 className={s.h2}>
                {h2Fourth}
              </h2>
              <div className={s.advertContainerGl}>
                <Googletag id="div-gpt-ad-1510239331518-2" />
              </div>
              <SortLine type="spares" />

              <PartList parts={parts} selectedCurrency={formState.currency} title={title} />

              {parts &&
                parts.length > 0 &&
                <Paginate
                  query={query}
                  url={url}
                  pageCount={pageCount > 100 ? 100 : pageCount}
                  initialPage={currentPage}
                />}
              <SeoTexts currentPath={currentPath} />
              <SpareRubricsLinks rubricsLinks={rubricsLinks} />
              <SpareSeoLinks seoCharacteristics={seoCharacteristics} />
            </div>
            <DesktopRightSidebar>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals, history: historyPath }) => ({
  formResults: searchForm && searchForm.results,
  formState: searchForm && searchForm.selected,
  formData: searchForm && searchForm.data,
  formVocabulary: searchForm && searchForm.vocabulary,
  locale: globals.locale,
  location: globals.location,
  currentPath: historyPath && historyPath.currentPath,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.sparesSetThunks,
      },
      dispatch,
    ),
    toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
    clear: bindActionCreators(formActions.selectedActions.clear),
    clearForm: bindActionCreators(formActions.sparesSetThunks.clearSelected, dispatch),
  },
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslate(Spareparts)),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/Spareparts.js